import { Car, Shield, Award } from 'lucide-react';
import type { DialogType, EdgeStyle, UnifiedCaseType, WorkflowChecklistItemType } from '@leal-crm/shared';
import type { BookingTypeInfoMap, EmailTemplate } from './types';

export const BOOKING_TYPE_INFO: BookingTypeInfoMap = {
  private: {
    name: 'Particular',
    icon: Car,
    description: 'Clientes particulares',
  },
  insurance: {
    name: 'Seguro',
    icon: Shield,
    description: 'Con compania de seguros',
  },
  warranty: {
    name: 'Garantia',
    icon: Award,
    description: 'En garantia del fabricante',
  },
};

export const BOOKING_TYPES = Object.keys(BOOKING_TYPE_INFO) as UnifiedCaseType[];

export const DIALOG_TYPE_LABELS: Record<DialogType, string> = {
  none: 'Ninguno',
  confirm: 'Confirmacion',
  notes: 'Notas',
  cancel: 'Cancelacion',
  complete: 'Completar',
  bay_select: 'Seleccion de bahia',
  quote: 'Presupuesto',
  custom: 'Personalizado',
};

export const CHECKLIST_TYPE_LABELS: Record<WorkflowChecklistItemType, string> = {
  photo: 'Foto',
  signature: 'Firma',
  file: 'Archivo',
  text: 'Texto',
  textarea: 'Texto largo',
  number: 'Numero',
  boolean: 'Checklist',
  select: 'Seleccion',
  multiselect: 'Seleccion multiple',
  date: 'Fecha',
  datetime: 'Fecha y hora',
};

export const CHECKLIST_SOURCES = [
  { value: 'workflow', label: 'Adjunto manual' },
  { value: 'booking_images', label: 'Fotos de la cita' },
  { value: 'intake_photos', label: 'Fotos de recepcion' },
  { value: 'repair_photos', label: 'Fotos de reparacion' },
];

export const EDGE_STYLE_LABELS: Record<EdgeStyle, string> = {
  default: 'Normal',
  dashed: 'Discontinuo',
  conditional: 'Condicional',
};

export const AVAILABLE_ROLES = [
  { value: 'admin', label: 'Administrador' },
  { value: 'technician', label: 'Tecnico' },
  { value: 'receptionist', label: 'Recepcionista' },
  { value: 'manager', label: 'Gerente' },
];

export const FALLBACK_EMAIL_TEMPLATES: EmailTemplate[] = [
  { id: 'booking-verification', name: 'Verificacion de Email', triggerEvent: 'booking_created', isActive: true },
  { id: 'booking-confirmed', name: 'Reserva Confirmada', triggerEvent: 'booking_confirmed', isActive: true },
  { id: 'booking-cancelled', name: 'Cita Cancelada', triggerEvent: 'booking_cancelled', isActive: true },
  { id: 'vehicle-checked-in', name: 'Vehiculo Recepcionado', triggerEvent: 'vehicle_checked_in', isActive: true },
  { id: 'estimate-ready', name: 'Presupuesto Listo', triggerEvent: 'estimate_ready', isActive: true },
  { id: 'delivery-signature', name: 'Firma de Entrega', triggerEvent: 'delivery_signature', isActive: true },
  { id: 'job-completed', name: 'Trabajo Completado', triggerEvent: 'job_completed', isActive: true },
];
